import { render, staticRenderFns } from "./all-choosed.vue?vue&type=template&id=a2983cd2&scoped=true"
import script from "./all-choosed.vue?vue&type=script&lang=js"
export * from "./all-choosed.vue?vue&type=script&lang=js"
import style0 from "./all-choosed.vue?vue&type=style&index=0&id=a2983cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2983cd2",
  null
  
)

export default component.exports